import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { authApi } from '../../api/authApi';

export default function RegisterPage() {
  const { setToken } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const loc = useLocation() as { state?: { from?: string } };
  const backTo = loc.state?.from ?? '/';

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    if (!email.trim() || !password || !fullName.trim()) {
      setError('Compila tutti i campi');
      return;
    }
    if (password.length < 6) {
      setError('La password deve essere di almeno 6 caratteri');
      return;
    }
    setLoading(true);
    try {
      const res = await authApi.register(email.trim(), password, fullName.trim()) as any;
      const token = res?.accessToken ?? res?.token;
      const userData = res?.user;
      if (!token) throw new Error('Risposta non valida dal server');
      setToken(token, userData ? { id: userData.id, email: userData.email, fullName: userData.fullName, role: userData.role } : null);
      nav(backTo, { replace: true });
    } catch (err: any) {
      const msg = err?.message ?? 'Registrazione fallita';
      setError(msg.includes('Email già') ? 'Email già registrata' : msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-card-header">
          <div className="auth-card-logo">
            <i className="bi bi-person-plus-fill" />
          </div>
          <h1 className="auth-card-title">Registrati</h1>
          <p className="auth-card-subtitle">
            Crea un account per accedere. Il primo utente sarà amministratore.
          </p>
        </div>

        <div className="auth-card-body">
          <form onSubmit={submit} className="auth-form">
            <div className="mb-3">
              <label htmlFor="reg-fullName" className="form-label">Nome completo</label>
              <input
                id="reg-fullName"
                type="text"
                className="form-control"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Mario Rossi"
                autoComplete="name"
              />
            </div>
            <div className="mb-3">
              <label htmlFor="reg-email" className="form-label">Email</label>
              <input
                id="reg-email"
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="es. mario@azienda.it"
                autoComplete="email"
              />
            </div>
            <div className="mb-3">
              <label htmlFor="reg-password" className="form-label">Password</label>
              <input
                id="reg-password"
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Min. 6 caratteri"
                autoComplete="new-password"
              />
            </div>
            {error && (
              <div className="alert alert-danger auth-alert mb-3" role="alert">
                <i className="bi bi-exclamation-circle me-2" />
                {error}
              </div>
            )}
            <button
              className="btn auth-btn-primary mb-0"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Registrazione...
                </>
              ) : (
                <>
                  <i className="bi bi-person-check me-2" />
                  Registrati e accedi
                </>
              )}
            </button>
          </form>

          <div className="auth-links text-center">
            <p className="mb-2">
              <Link to="/forgot-password">Password dimenticata?</Link>
            </p>
            <p className="mb-0 text-muted small">
              Hai già un account?{' '}
              <Link to="/login" state={loc.state}>Accedi</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
